import { AnalyzeError } from "#modules/quoteRequestLines/AnalyzeError";

type Props = {
  errorText: string;
  retryText: string;
  onRetryPrediction: () => void;
};

export const NoPredictionState = ({ errorText, retryText, onRetryPrediction }: Props) => {
  return (
    <AnalyzeError errorText={errorText} retryText={retryText} retryAction={onRetryPrediction} />
  );
};
